import Parse from 'html-react-parser';

function BMP20185(props) {
    let svgCode =
    `<svg width="1384" height="156" viewBox="0 0 1384 156" fill="none" xmlns="http://www.w3.org/2000/svg">
    <style type="text/css">
    .boxStyle rect {
        ${props.boxStyle}
    }
    ${props.fontFace}
    </style>
    <g class="boxStyle">
        <rect width="1384" height="156" fill="${props.backgroundFill}" stroke="${props.outlineColour}" stroke-width="5"/>
        <circle cx="970" cy="63.4546" r="36" fill="${props.paramFill}"/>
        <rect x="967.818" y="22" width="4.36364" height="4.36364" fill="${props.paramFill}"/>
        <rect x="938.551" y="91.8182" width="4.36364" height="4.36364" transform="rotate(-45 938.551 91.8182)" fill="${props.paramFill}"/>
        <rect x="995.091" y="91.6312" width="4.36364" height="4.36364" transform="rotate(-45 995.091 91.6312)" fill="${props.paramFill}"/>
        <circle cx="1250" cy="63.4546" r="36" fill="${props.paramFill}"/>
        <rect x="1247.82" y="22" width="4.36364" height="4.36364" fill="${props.paramFill}"/>
        <rect x="1218.55" y="91.8182" width="4.36364" height="4.36364" transform="rotate(-45 1218.55 91.8182)" fill="${props.paramFill}"/>
        <rect x="1275.09" y="91.6312" width="4.36364" height="4.36364" transform="rotate(-45 1275.09 91.6312)" fill="${props.paramFill}"/>
        <path class="paramBoxStyle" d="M0 54H175C177.761 54 180 56.2386 180 59V97C180 99.7614 177.761 102 175 102H0V54Z" fill="#EA7C05"/>
        <rect x="215" y="52" width="262" height="51" rx="4" fill="${props.paramFill}"/>
        <rect x="597" y="18" width="290" height="119" rx="5" fill="${props.paramFill}"/>
        <rect x="917" y="115" width="106" height="28" rx="4" fill="${props.paramFill}"/>
        <rect x="1052" y="18" width="118" height="120" rx="4" fill="${props.paramFill}"/>
        <rect x="1196" y="112" width="106" height="24" rx="4" fill="${props.paramFill}"/>
        <g letter-spacing="${props.fontExtras.space}" font-weight="${props.fontExtras.weight}" fill="${props.fontColour}" font-family="${props.fontName}">
        <text fill="black" font-size="27"><tspan x="12" y="88.2285">DISTORTION</tspan></text>
        <text font-size="16"><tspan x="537" y="41.9688">OFF</tspan></text>
        <text font-size="16"><tspan x="537" y="83.9688">PRE</tspan></text>
        <text font-size="16"><tspan x="537" y="125.969">POST</tspan></text>
        <text font-size="14"><tspan x="610" y="125.785">F</tspan></text>
        <text font-size="16"><tspan x="851" y="45.9688">HP</tspan></text>
        <text font-size="16"><tspan x="852" y="83.9688">BP</tspan></text>
        <text font-size="16"><tspan x="853" y="119.969">LP</tspan></text>
        <text font-size="16"><tspan x="1234" y="129.969">MIX</tspan></text>
        <text font-size="16"><tspan x="946" y="129.969">DRIVE</tspan></text>
        </g>
        <path d="M159 78L167.66 68.25H150.34L159 78Z" fill="black"/>
        </g>
    </svg>`

    props.svgReturn(94, svgCode, "bmp00185", 1384, 156);

    return (
        Parse(svgCode)
    );
}

export default BMP20185;